$(document).ready(function () {
  let slider_container = $(".slider--main-container");
  
  $('.controller-action').on('click', function () {
    slider_container.css('overflow-x', 'auto');
    
 
    
    let data_index = parseInt($(this).data('index')), controllers = $(".slider-controller");
    let slide_index = data_index < 0 ? controllers.length-1 : data_index == controllers.length ? 0 :  data_index;

    let next_element_scroll_pos = $(".slider--main-container .slider-item").eq(slide_index).position().left;
    let margin_right = parseInt(getComputedStyle(document.querySelector(".slider-item")).marginRight);
    
    
  
    
    
    let scroll_position = slide_index * ($(".slider-item").eq(slide_index).width() + margin_right);
   /* console.log({
      "Slide index": slide_index,
      "Next element scroll position": scroll_position,
      "Slider scroll position": slider_container.scrollLeft(),
      "Margin right": margin_right,
      "Width": $(".slider-item").eq(slide_index).width()
    })*/
    
    slider_container.animate({scrollLeft: scroll_position}, {
      duration: 500,
      complete: function () {
      	slider_container.removeAttr('style');
      }
    })
  })
})